import React from 'react'
import classNames from 'classnames'
import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser'
import PropTypes from 'prop-types'

import styles from './formMessage.module.scss'

const FormMessage = (props) => {
  const {
    content,
    expand,
    position,
    clearErrors,
    clearErrorsOnClick,
    onClick,
    ...rest
  } = props
  return (
    <div
      className={classNames(styles.messageContainer, styles[position])}
      style={{ flexGrow: expand || 1 }}
    >
      <span className={styles.message} {...rest}>
        {ReactHtmlParser(content, {
          transform: (node, index) => {
            if (node.type === 'tag' && node.name === 'a') {
              return (
                <a
                  className={styles.anchor}
                  onClick={(event) => {
                    clearErrorsOnClick && clearErrors && clearErrors()
                    onClick && onClick(event)
                  }}
                  {...rest}
                  key={index}
                >
                  {node.children.map((n) => convertNodeToElement(n))}
                </a>
              )
            }
          }
        })}
      </span>
    </div>
  )
}

FormMessage.propTypes = {
  content: PropTypes.string,
  expand: PropTypes.number,
  position: PropTypes.string
}

export default FormMessage
